


import convenient from '../../../src/assets/images/sub-pages/whatWeDo/solutions/webrtcInfrastructureAsCode/convenient.png';
import affordable from '../../../src/assets/images/sub-pages/whatWeDo/solutions/webrtcInfrastructureAsCode/affordable.png';
import zerohumanerrors from '../../../src/assets/images/sub-pages/whatWeDo/solutions/webrtcInfrastructureAsCode/zero-human-errors.png';
import multishard from '../../../src/assets/images/sub-pages/whatWeDo/solutions/webrtcInfrastructureAsCode/multi-shard.png';
import singleshard from '../../../src/assets/images/sub-pages/whatWeDo/solutions/webrtcInfrastructureAsCode/single-shard.png';
import multiregion from '../../../src/assets/images/sub-pages/whatWeDo/solutions/webrtcInfrastructureAsCode/multi-region.png';
import header_image from '../../../src/assets/images/sub-pages/whatWeDo/solutions/webrtcInfrastructureAsCode/webrtc infrastructure as code.webp';

const webrtcInfrastructureAsCode =
{
    pageHeading: 'AWS Terraform and multi-platform Kubernetes Jitsi Infrastructure as Code',
    pageDescription: 'Building a video conferencing platform never got any better! We bring to you tailor-made terraform scripts for installation of Jitsi meet in AWS (Amazon web services), GCP (Google Cloud Platform), Microsoft Azure cloud infrastructure',
    // buttonOneText: 'Read More',
    image: header_image,
    gridGroupList: [
        {
            gridHeadingStrong: 'Easy set up of Video Conferencing platforms with ready made scripts.',
            gridDescription: 'Explanatory guides help you build infrastructure easily. Save time coding with our pre-built Kubernetes scripts that support deploying Jitsi Meet in AWS, GCP or Azure.',
            gridItems: [
                {
                    image: convenient,
                    heading: "Convenient",
                    description: "Save time and the hassle of coding from scratch. Our ready made codified APIs into declarative configuration files and scripts are here to help you."
                },
                {
                    image: zerohumanerrors,
                    heading: "Zero Human Errors",
                    description: "Built and executed carefully for installation of Jitsi meet in AWS (Amazon web services), GCP (Google Cloud Platform), Microsoft Azure cloud infrastructure."
                },
                {
                    image: affordable,
                    heading: "Affordable",
                    description: "Budget friendly Terraform script in hand to build a complete video conferencing platform for your business entity."
                }
            ]
        }
    ],
    pricingView: {
        pricingCards: [
            {
                cardData: {
                    heading: 'Terraform Single Shard Deployment',
                    image: singleshard,
                    subHeading: 'AWS',
                    checkList: [
                        {
                            text: 'Jitsi Meet Installation',
                        },
                        {
                            text: 'Terraform Script',
                        },
                        {
                            text: 'Jibri Autoscaling',
                        },
                        {
                            text: 'User Guide',
                        },
                        {
                            text: 'Load Balancing with HA Proxy',
                        },
                        {
                            text: 'Auto scaling JVBs to support 500 concurrent users',
                        },
                        {
                            text: 'Octo setup',
                            crossOut: true,
                        },
                    ],
                },
            },
            {
                cardData: {
                    heading: 'Kubernetes Single Shard Deployment',
                    image: multishard,
                    subHeading: 'AWS, GCP, Azure',
                    // description: 'sample description',
                    checkList: [
                        {
                            text: 'Jitsi Meet Installation',
                        },
                        {
                            text: 'Terraform Script',
                        },
                        {
                            text: 'Jibri Autoscaling',
                        },
                        {
                            text: 'User Guide',
                        },
                        {
                            text: 'Load Balancing with HA Proxy',
                        },
                        {
                            text: 'Auto scaling JVBs to support 500 concurrent users',
                        },
                        {
                            text: 'Octo setup',
                            crossOut: true,
                        },
                    ],
                },
            },
            {
                cardData: {
                    heading: 'Custom Terraform or Kubernetes Jitsi Code',
                    image: multiregion,
                    subHeading: 'Get infrastructure code fine tuned for your requirement',
                    // description: 'sample description',
                    checkList: [
                        {
                            text: 'Jitsi Meet Installation',
                        },
                        {
                            text: 'Terraform Script',
                        },
                        {
                            text: 'Jibri Autoscaling',
                        },
                        {
                            text: 'User Guide',
                        },
                        {
                            text: 'Load Balancing with HA Proxy',
                        },
                        {
                            text: 'Auto scaling JVBs to support 500 concurrent users',
                        },
                        {
                            text: 'Octo setup',
                        },
                    ],
                },
            },
        ]
    }
}


export default webrtcInfrastructureAsCode;